export default "__VITE_ASSET__6pP1f0L1__"